var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"show-schedule-mix-block"},_vm._l((_vm.resources),function(resource){return _c(_setup.ShowScheduleVerticalTile,{key:`${resource.id}${resource.scheduled_start_time}`,attrs:{"playlist-item":resource,"artwork":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }